import { Eye } from 'lucide-react';

/**
 * InfoDot — a small circle with an eye. Hover (or keyboard-focus) reveals the
 * explanatory `text` in a tooltip, so the UI stays clean instead of carrying
 * verbose inline helper paragraphs.
 */
export function InfoDot({ text, className }: { text: string; className?: string }) {
  return (
    <span className={`relative inline-flex group/infodot align-middle ${className ?? ''}`}>
      <button
        type="button"
        aria-label={text}
        className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-brix-border text-brix-muted hover:text-brix-primary hover:border-brix-primary/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-brix-primary/40 transition-colors"
      >
        <Eye size={10} />
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 top-full z-50 mt-1.5 w-64 max-w-[75vw] -translate-x-1/2 rounded-lg bg-slate-900 px-3 py-2 text-[11px] font-normal leading-relaxed text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover/infodot:opacity-100 group-focus-within/infodot:opacity-100"
      >
        {text}
      </span>
    </span>
  );
}
